import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable, combineLatest, from, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import {KeycloakLv1871Service} from '@lv1871/core';

@Injectable()
export class KeycloakInterceptorService implements HttpInterceptor {
  constructor() {}


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('access_token');
    if (!!token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }
    return next.handle(req);
  }
}
